import { Rating } from '@material-ui/lab';
import SurveyAgent from 'assets/icons/Agente.png';
import { ReactComponent as SurveyMarker } from 'assets/icons/marker_VI.svg';
import ConfirmButton from 'components/common/ConfirmButton';
import HeliosClient from 'context/Helios';
import { AppContext, Brands } from 'context/interfaces';
import { genResumeEmail } from 'context/Utils';
import React, { FunctionComponent, useContext, useState } from 'react';
import { SurveyPayload } from 'types/survey';
import DefaultSurvey from './forms/Default';
import SMSurvey from './forms/SMSurvey';
import { useParams } from 'react-router';
import { Context } from '../../context/Context';

interface BodyProps {
	handleSubmit: (data: SurveyPayload) => void;
	urlToRedirect: string;
}

const BRAND = process.env.REACT_APP_BRAND?.toLocaleLowerCase();

export const BodySurvey: FunctionComponent<BodyProps> = ({ handleSubmit, urlToRedirect }: BodyProps): JSX.Element => {
	const [recommend, setRecommend] = useState<number | null>(null);
	const [experience, setExperience] = useState<number | null>(null);
	const [agentGrade, setAgentGrade] = useState<number | null>(null);
	const [comment, setComment] = useState<string>('');
	const [indInconvenient, setIndInconvenient] = useState<string>('');
	const [inconvenient, setInconvenient] = useState<string>('');
	const [isVisible, setIsVisible] = useState<boolean>(true);
	const eventRecord = JSON.parse(localStorage.getItem('state') || '{}').eventId;
	const { id } = useParams<{ id: string }>();
	const context = useContext(Context) as AppContext;

	const handleFormSubmit = () => {
		//Finish service just for PR
		if (
			BRAND === Brands.PREMIER ||
			BRAND === Brands.OPTIMA ||
			BRAND === Brands.MULTINATIONAL ||
			BRAND === Brands.SODA
		) {
			handleFinishService(id, context);
		}

		handleSubmit({
			recommend: Number(recommend),
			comment: comment,
			experience: Number(experience),
			inconvenient: inconvenient,
			indInconvenient: indInconvenient,
			inspectionId: 0,
			agentGrade: agentGrade === null ? 0 : agentGrade,
		});
		genResumeEmail(eventRecord);
	};

	const handleFinishService = async (idFromParams: string, context: AppContext) => {
		try {
			let serviceId = localStorage.getItem('ServiceId');

			if (!serviceId && idFromParams) {
				const data = await new HeliosClient().getInspection(idFromParams, context);
				serviceId = data?.serviceId;
			}

			if (serviceId) {
				const data = {
					logMessage: 'Finished service by IV.',
					mongoServiceId: serviceId,
					serviceId: serviceId,
					_id: serviceId,
				};

				const response = await new HeliosClient().finishService(data);
				console.log('Service finished:', response); // Mejor que alert
			} else {
				console.warn('Ningún service Id asociado para finalizar');
			}
		} catch (error) {
			console.error('Error finishing service:', error);
		}
	};

	const handleChange = (value: string) => {
		if (value === 'Si') setIsVisible(false);
		if (value === 'No') setIsVisible(true);
		setIndInconvenient(value);
	};

	const handleChangeRecommended = (value: number) => {
		setRecommend(Number(value));
	};

	return (
		<>
			<div className="survey-container">
				<form className="questions" onSubmit={handleFormSubmit}>
					{BRAND !== Brands.SEGUROS_MUNDIAL && BRAND !== Brands.COMFENALCO && (
						<>
							<hr className="rate-divider" />
							<div className="rate-examples">
								<div className="rate-example">
									<Rating value={1} readOnly size="large" />
									<span className="rate-label">= Pobre</span>
								</div>
								<div className="rate-example">
									<Rating value={5} readOnly size="large" />
									<span className="rate-label">= Excelente</span>
								</div>
							</div>
							<hr className="rate-divider" />
							<div className="question">
								<div className="question__rate">
									<p className="question__text">¿Cómo calificarías tu experiencia con esta aplicación?</p>
									<Rating
										name="experience"
										value={experience}
										size="large"
										onChange={(event: React.ChangeEvent<{}>, newValue: number | null) => {
											setExperience(newValue);
										}}
									/>
								</div>
								<div className="question__image">
									<SurveyMarker />
								</div>
							</div>
							<hr className="rate-divider" />
							<div className="question">
								<div className="question__rate">
									<p className="question__text">¿Cómo calificarías al coordinador de servicio?</p>
									<Rating
										name="agentGrade"
										value={agentGrade}
										size="large"
										onChange={(event: React.ChangeEvent<{}>, newNote: number | null) => {
											setAgentGrade(newNote);
										}}
									/>
								</div>
								<div className="question__image">
									<img src={SurveyAgent} width="84px" height="82px" alt="agent" />
								</div>
							</div>
						</>
					)}

					{(BRAND === Brands.SEGUROS_MUNDIAL || BRAND === Brands.COMFENALCO) && (
						<SMSurvey
							handleChange={handleChange}
							handleChangeRecommended={handleChangeRecommended}
							inconvenient={inconvenient}
							setInconvenient={setInconvenient}
							setExperience={setExperience}
							isVisible={isVisible}
						/>
					)}
					{BRAND !== Brands.SEGUROS_MUNDIAL && BRAND !== Brands.COMFENALCO && (
						<DefaultSurvey recommend={recommend} setRecommend={setRecommend} />
					)}
					<hr className="section-divider" />
					<div className="question--comment">
						<p className="question__text">Comentarios adicionales:</p>
						<textarea rows={5} value={comment} onChange={(e) => setComment(e.target.value)}></textarea>
					</div>
				</form>
			</div>

			<ConfirmButton text="Enviar" to={urlToRedirect} onClick={handleFormSubmit} />
		</>
	);
};

export default BodySurvey;
